<template>
  <maps-card
    ref="map"
    v-model:picker-coordinates="pickerCoordinated"
    class="w-100 h-100"
    picker
    :read-only="readOnly"
    :force-map="forceMap"
    :zoom="zoom"
    :center="pickerCoordinated"
    :additional-assets="additionalAssets"
    @location-changed="(e: LatLngAlt) => (pickerCoordinated = e)"
  />
</template>

<script setup lang="ts">
const pickerCoordinated = defineModel<LatLngAlt>()

const mapRef = useTemplateRef<MapsCardInstance>("map")

const {
  zoom = 7,
  readOnly = false,
  forceMap = undefined,
  additionalAssets = []
} = defineProps<{
  zoom?: number
  readOnly?: boolean
  forceMap?: "google" | "openLayers"
  additionalAssets?: Array<LookupAsset>
}>()

const mapInstance = computed(() => mapRef.value?.map)

defineExpose({
  map: mapInstance,
})
</script>
